import { isGeomKind, type ShapeToolKind } from "@bezpart-board/shared";
import {
  diamondPathD,
  geomPathD,
  starPathD,
  trianglePathD,
} from "../../editor/geometry/shapePaths";
import { geomVolumeLayers, isVolumeGeomKind } from "../../editor/geometry/volumeShapes";

type Props = {
  kind: ShapeToolKind;
  className?: string;
};

export function ShapeKindIcon({ kind, className }: Props) {
  if (kind === "rect") {
    return (
      <svg className={className} viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
        <rect
          x="3.5"
          y="5.5"
          width="17"
          height="13"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
  if (kind === "ellipse") {
    return (
      <svg className={className} viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
        <ellipse
          cx="12"
          cy="12"
          rx="8.5"
          ry="7"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
        />
      </svg>
    );
  }

  if (isGeomKind(kind) && isVolumeGeomKind(kind)) {
    const layers = (geomVolumeLayers(kind, 24, 24) ?? []).filter((l) => l.paint !== "fill");
    return (
      <svg
        className={className}
        viewBox="0 0 24 24"
        width="20"
        height="20"
        aria-hidden="true"
        focusable="false"
      >
        {layers.map((layer, i) => (
          <path
            key={`${layer.paint}-${i}`}
            d={layer.d}
            fill="none"
            stroke="currentColor"
            strokeWidth="1.35"
            strokeLinejoin="round"
            strokeLinecap="round"
            strokeDasharray={layer.paint === "dashed" ? "2.2 2.2" : undefined}
          />
        ))}
      </svg>
    );
  }

  let d: string;
  let evenodd = false;
  if (kind === "triangle") d = trianglePathD(24, 24);
  else if (kind === "diamond") d = diamondPathD(24, 24);
  else if (kind === "star") d = starPathD(24, 24, 5);
  else if (isGeomKind(kind)) {
    d = geomPathD(kind, 24, 24);
    evenodd = kind === "ring";
  } else {
    d = diamondPathD(24, 24);
  }

  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      width="20"
      height="20"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d={d}
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
        strokeLinecap="round"
        fillRule={evenodd ? "evenodd" : undefined}
      />
    </svg>
  );
}
